import Vue from 'vue'
import PageIndex from './components/PageIndex.vue'
import Particuliers from './components/Particuliers.vue'
import Entreprises from './components/Entreprises.vue'
import Relax from './components/Relax.vue'
import Accompagnements from './components/Accompagnements.vue'

import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin) 

import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    routes: [{
        path: '/',
        component: PageIndex,
        name: 'index'
    },{
        path: '/Particuliers',
        component: Particuliers,
        name: 'Particuliers'
    },{
        path: '/Entreprises',
        component: Entreprises,
        name: 'Entreprises'
    },{
        path: '/Relax',
        component: Relax,
        name: 'Relax'
    },{
        path: '/Accompagnements',
        component: Accompagnements,
        name: 'Accompagnements'
    }]
})

import 'leaflet/dist/leaflet.css';

const prod = process.env.NODE_ENV === 'production'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
require('./assets/css/EVStyles.css')
require('./assets/css/GoogleMaterials.css')

import { CarouselPlugin} from 'bootstrap-vue'
Vue.use(CarouselPlugin)

import Textra from 'vue-textra'
Vue.use(Textra);

Vue.config.productionTip = false

import App from './App'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
